<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="土地ID">
                <a-input v-model="queryParam.landId" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="用户ID">
                <a-input v-model="queryParam.userId" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="种植状态">
                <a-select v-model="queryParam.status" allowClear>
                  <a-select-option :value="1">种植中</a-select-option>
                  <a-select-option :value="2">已收获</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false" :bordered="tableBordered">
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 1" color="green">种植中</a-tag>
          <a-tag v-else-if="record.status === 2" color="blue">已收获</a-tag>
        </span>
        <span slot="plantTime" slot-scope="text, record">{{ parseTime(record.plantTime) }}</span>
        <span slot="createTime" slot-scope="text, record">{{ parseTime(record.createTime) }}</span>
      </a-table>
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum" :total="total" :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`" @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePlantRecord } from '@/api/cloudplant/plantRecord'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'LandPlantRecord',
  mixins: [tableMixin],
  data() {
    return {
      list: [], loading: false, pageSizeOptions: ['10', '20', '50', '100'], total: 0,
      queryParam: { landId: undefined, userId: undefined, status: undefined, pageNum: 1, pageSize: 10 },
      columns: [
        { title: '土地ID', dataIndex: 'landId', align: 'center' },
        { title: '用户ID', dataIndex: 'userId', align: 'center' },
        { title: '种子ID', dataIndex: 'seedId', align: 'center' },
        { title: '种子名称', dataIndex: 'seedName', align: 'center' },
        { title: '种植状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center', width: 100 },
        { title: '种植时间', dataIndex: 'plantTime', scopedSlots: { customRender: 'plantTime' }, align: 'center', width: 160 },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center', width: 160 }
      ]
    }
  },
  created() { this.getList() },
  methods: {
    getList() { this.loading = true; pagePlantRecord(this.queryParam).then(response => { this.list = response.data.records; this.total = response.data.total; this.loading = false }) },
    handleQuery() { this.queryParam.pageNum = 1; this.getList() },
    resetQuery() { this.queryParam = { landId: undefined, userId: undefined, status: undefined, pageNum: 1, pageSize: 10 }; this.handleQuery() },
    onShowSizeChange(current, pageSize) { this.queryParam.pageSize = pageSize; this.getList() },
    changeSize(current, pageSize) { this.queryParam.pageNum = current; this.queryParam.pageSize = pageSize; this.getList() }
  }
}
</script>
